var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.showAttr('OzonProductsDC')}}},on),[_c('v-icon',[_vm._v("mdi-alpha-o-circle-outline")])],1)]}}])},[_c('span',[_vm._v("Показать атрибуты Озон")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }